import { FC } from 'react'

import * as S from './CalendarLegend.styles'

type LegendItem = {
  title: string
  color: string
}

type CalendarLegendProps = {
  items: LegendItem[]
}

export const CalendarLegend: FC<CalendarLegendProps> = ({ items }) => {
  return (
    <S.LegendContainer>
      {items.map(({ title, color }) => (
        <S.LegendItem key={title}>
          <S.Circle color={color} />
          <S.LegendItemTitle>{title}</S.LegendItemTitle>
        </S.LegendItem>
      ))}
    </S.LegendContainer>
  )
}
